module.exports = __webpack_public_path__ + "static/media/feature-reports.5b9d3ce7.png";